// extracted by mini-css-extract-plugin
module.exports = {"partners":"RSqNY","partnerSelectionPanelWrapper":"hjjrs","partnerSelectionPanelCount":"D8jQI"};